import classNames from "@/utils/classNames";
import { homePageFor } from "@/utils/homePage";
import { useIdentity } from "@/utils/identity";
import { Link } from "@/utils/navigation";

type ApplicationLogoProps = {
    useDark?: boolean;
    useStrawberry?: boolean;
    allowClick?: boolean;
    imgClasses?: string;
};

export default function ApplicationLogo({
    useDark,
    useStrawberry,
    allowClick = true,
    imgClasses = "",
}: ApplicationLogoProps) {
    const { user, isImpersonating } = useIdentity();

    return (
        <div className="flex">
            {isImpersonating ? (
                <div>
                    <span className="text-white">
                        Logged as {user?.type} id: {user?.id}
                    </span>
                    <a href={route("impersonate.leave")}>
                        <div className="text-white">Leave Impersonation</div>
                    </a>
                </div>
            ) : allowClick ? (
                <Link href={homePageFor(user)} aria-label="Go to home page">
                    <LogoImage
                        useDark={useDark}
                        useStrawberry={useStrawberry}
                        imgClasses={imgClasses}
                    />
                </Link>
            ) : (
                <LogoImage
                    useDark={useDark}
                    useStrawberry={useStrawberry}
                    imgClasses={imgClasses}
                />
            )}
        </div>
    );
}

function logoFileName(useDark?: boolean, useStrawberry?: boolean): string {
    if (useStrawberry) {
        return "logoStrawbrry";
    }
    return useDark ? "logoDark" : "logo";
}

function LogoImage({
    useDark,
    useStrawberry,
    imgClasses,
}: {
    useDark?: boolean;
    useStrawberry?: boolean;
    imgClasses: string;
}) {
    return (
        <img
            src={`${import.meta.env.VITE_CDN_URL}/images/${logoFileName(useDark, useStrawberry)}.webp`}
            alt="Coaching Box Logo"
            className={classNames("mr-2 h-8 sm:mr-6", imgClasses)}
        />
    );
}
